export default {
  "article.back": "← Powrót do strony głównej",
  "article.readTime": "min czytania",
  "article.published": "Opublikowano",
  "article.updated": "Ostatnia aktualizacja",
  "article.relatedTitle": "Powiązane artykuły",
  "article.ctaBottom": "Sprawdź Kakobuy Spreadsheet już teraz",
  "article.toc": "Spis treści",
  "article.share": "Udostępnij",
  "article.tags": "Tagi"
}